import type { SupportedLanguage } from '@/i18n/i18n'

export function LanguageSegmentedControl({
  language,
  onLanguageChange,
  t,
}: {
  language: SupportedLanguage
  onLanguageChange: (language: SupportedLanguage) => void
  t: (key: string) => string
}) {
  const options: { label: string; value: SupportedLanguage }[] = [
    { label: t('language.simplifiedChinese'), value: 'zh-Hans' },
    { label: t('language.english'), value: 'en-US' },
  ]

  return (
    <div
      aria-label={t('language.ariaLabel')}
      className="inline-flex h-8 items-center gap-2 text-sm"
      role="radiogroup"
    >
      {options.map((option, index) => (
        <span className="inline-flex items-center gap-2" key={option.value}>
          {index > 0 ? <span className="h-3 w-px bg-[rgba(26,28,25,0.22)]" /> : null}
          <button
            aria-checked={language === option.value}
            className={
              language === option.value
                ? 'cursor-pointer text-sm font-semibold text-[var(--color-primary)]'
                : 'cursor-pointer text-sm font-medium text-[var(--color-text-muted)] transition-colors hover:text-[var(--color-text)]'
            }
            key={option.value}
            onClick={() => onLanguageChange(option.value)}
            role="radio"
            type="button"
          >
            {option.label}
          </button>
        </span>
      ))}
    </div>
  )
}
